import { render, staticRenderFns } from "./DriverPriceForm.vue?vue&type=template&id=0b313998&"
import script from "./DriverPriceForm.vue?vue&type=script&lang=js&"
export * from "./DriverPriceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports